import { io } from "socket.io-client";

const URL = process.env.REACT_APP_SOCKET_API_URL;

export const socketAiAssistant = io(URL, {
  transports: ["websocket", "polling"],
});

